import React from "react";
import { Link } from "react-router-dom";
import TitlePanel from "./title_panel/TitlePanel";

import "./TitlesPage.css"
import "./TitlesGeneric.css"

var inequalities_formula = "$(sum_(k=0)^n a_k)/n ge (root(n)(prod_(k=0)^n a_k))$";
var integrals_formula = "$int\f(x,t)dx$";
var series_formula = "$sum_(n)f_n(x)$";
var rog_formula = "$\"Rew\" -> \"Op\" -> \"Gen\"$";
var math_ai_formula = "$nabla_theta cc(L)(theta)$";
// var rog2_formula = "$\"Rew\"(T) -= T$";

const TitlesPageGeneric = () => {
    return (
        <div className="titles-page-div">
            <div className="choose-topic-div">
                <h2>Choose a topic</h2>
                <div className="premium-notice">
                    <span className="premium-lock" aria-hidden="true">🔒</span>
                    <span>
                        Some topics require <strong>Premium access</strong>.
                        Select a premium topic to subscribe.
                    </span>
                </div>
            </div>
            <div className="titles-container">
                <Link to="/rog-framework" style={{ textDecoration: 'none' }}>
                    <TitlePanel title="ROG Framework" formula={rog_formula}/>
                </Link>

                {/* <Link to="/rog-framework-v2" style={{ textDecoration: 'none' }}>
                    <TitlePanel title="ROG Framework v2" formula={rog2_formula}/>
                </Link> */}

                <Link to="/advanced/integrals" style={{ textDecoration: 'none' }}>
                    <TitlePanel title="Integrals" formula={integrals_formula}/>
                </Link>

                <Link to="/advanced/series" style={{ textDecoration: 'none' }}>
                    <TitlePanel title="Series" formula={series_formula}/>
                </Link>

                <Link to="/payment" style={{ textDecoration: 'none' }} className="premium-link">
                    <div className="premium-panel-wrapper">
                        <span className="premium-badge">Premium</span>
                        <TitlePanel title="Inequalities" formula={inequalities_formula}/>
                    </div>
                </Link>

                <Link to="/payment" style={{ textDecoration: 'none' }} className="premium-link">
                    <div className="premium-panel-wrapper">
                        <span className="premium-badge">Premium</span>
                        <TitlePanel title="Math for AI" formula={math_ai_formula}/>
                    </div>
                </Link>
            </div>
        </div>
    );
}

export default TitlesPageGeneric;
